import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class TaskPriorityService extends BaseService {
  protected baseUrl = '/task-priority';
}
